import { render, staticRenderFns } from "./ProfileNotifications.vue?vue&type=template&id=e411c9c2&"
import script from "./ProfileNotifications.vue?vue&type=script&lang=js&"
export * from "./ProfileNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports